import { Component, OnInit } from '@angular/core';
import { ToastController, PopoverController, NavParams } from '@ionic/angular';
import { UtilsService } from 'src/app/core/services/utils/utils.service';

@Component({
  selector: 'app-order-details-popover',
  templateUrl: './order-details-popover.component.html',
  styleUrls: ['./order-details-popover.component.scss'],
})
export class OrderDetailsPopoverComponent implements OnInit {

  public details;
  public culture = 'es-CL';
  
  constructor(
    private toastCtrl: ToastController,
    private popoverCtlr: PopoverController,
    private navParams: NavParams,
    public utils: UtilsService
  ) {
    this.details = this.navParams.get('details');
  }

  async ngOnInit() {
    this.culture = await this.utils.getCulture();
  }



}
